export default "__VITE_ASSET__bccf0223__"